module.exports = __webpack_public_path__ + "media/ח.50677353.mp3";